export default __webpack_public_path__ + "85cf592113e28eac997b01245415beec.svg";